import { render, staticRenderFns } from "./ViewDiolog.vue?vue&type=template&id=a70ddccc&scoped=true"
import script from "./ViewDiolog.vue?vue&type=script&lang=js"
export * from "./ViewDiolog.vue?vue&type=script&lang=js"
import style0 from "./ViewDiolog.vue?vue&type=style&index=0&id=a70ddccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70ddccc",
  null
  
)

export default component.exports